import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('common');
  return (
    <div className="min-h-[100dvh] bg-background text-foreground selection:bg-primary/30">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-modal focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary-foreground"
      >
        {t('skipToContent')}
      </a>
      <Navbar />
      <main id="main">{children}</main>
      <Footer />
      <div aria-hidden className="grain" />
    </div>
  );
};

export default Layout;
